var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('v-btn',{staticClass:"track-order-button",attrs:{"height":"40","color":"secondary"},on:{"click":function($event){return _vm.setSelectedOrderNumber(_vm.orderId)}}},[_c('status-delivering',{attrs:{"tracking-button":true}}),_c('span',{staticClass:"text"},[_vm._v("Track Order")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }